import { baseQuery } from "./baseQuery";
import { createApi } from "@reduxjs/toolkit/query/react";
import { StatusResponeApi } from "constants/common.constants";
import { DataResponse } from "shared/models";
import { v4 as uuidv4 } from "uuid";

export const infoService = createApi({
  reducerPath: "infoService",
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getMerchantPayableAmount: builder.query<
      any,
      { merchants: string[]; time?: string; exRate?: boolean; currencyCode?: string }
    >({
      query: (params) => ({
        url: `/info/payable`,
        method: "GET",
        params,
      }),
    }),
    getCardBrandSupported: builder.query<any, void>({
      query: () => ({
        url: `/info/support-card-brand`,
        method: "GET",
      }),
      transformResponse: (rawData: any) => {
        if (rawData.success) {
          return rawData.data;
        }
      },
    }),
    getWalletSupported: builder.query<any, void>({
      query: () => ({
        url: `/info/support-wallet`,
        method: "GET",
      }),
      transformResponse: (rawData: any) => {
        if (rawData.success) {
          return rawData.data;
        }
      },
    }),
    uploadFile: builder.mutation<DataResponse<string[]>, FormData>({
      query: (formData) => ({
        url: "/info/uploadFile",
        body: formData,
        method: "POST",
      }),
    }),
    downloadFile: builder.mutation<any, { path: string; name: string }>({
      query: (body: any) => ({
        url: `/info/downloadFile`,
        body,
        method: "POST",
        responseHandler: async (response) => {
          if(response?.status === StatusResponeApi.SUCCESS){
            const url = window.URL.createObjectURL(await response.blob());
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", body?.name);
            link.setAttribute("target", "_blank");
            document.body.appendChild(link);
            link.click();
            URL.revokeObjectURL(url);
          }
          return response;
        },
      }),
    }),
  }),
});

export const { 
  useLazyGetMerchantPayableAmountQuery, 
  useUploadFileMutation, 
  useDownloadFileMutation, 
  useGetCardBrandSupportedQuery,
  useGetWalletSupportedQuery,
} = infoService;
